export interface CancelAppointment {
  cancellationReason: string;
  id: string;
}

export enum AppointmentInformationTab {
  next = "next",
  selected = "selected",
}
